<!-- @format -->

@if (shipToMeButtonText$ | async; as shipToMeButtonText) {
	<div id="pdp-ship-to-me-button">
		<pdp-add-to-cart-component-fulfillment-button
			#fulfillmentButton
			[isSelected]="(shipMode$ | async) === 'shipToMe'"
			[isDisabled]="shipToMeButtonText.fulfillmentButtonDisabledClass"
			(buttonClicked)="setShipMode()">
			<homefield-icon
				class="fulfillment-icon dynamic-fill"
				width="36px"
				height="36px"
				[name]="fulfillmentIconName">
			</homefield-icon>
			<span fulfillment-type-label>Ship</span>
			<span fulfillmentText>
				<div class="hmf-display-flex hmf-align-items-center">
					<span>
						{{ shipToMeButtonText.fulfillmentButtonText }}
					</span>
				</div>
				@if (skuEDDEnabled && shipToMeButtonText.showEDD) {
					@if (
						(EDDDisplayVerbiage$ | async) !== '' &&
						(EDDDisplayVerbiage$ | async) !== 'na'
					) {
						<div class="hmf-mt-xxxs hmf-body-s hmf-body-md-m edd-message">
							{{ EDDDisplayVerbiage$ | async }}
						</div>
					}

					@if ((EDDDisplayVerbiage$ | async) === undefined) {
						<div class="message-loader"></div>
					}
				}
			</span>
		</pdp-add-to-cart-component-fulfillment-button>
	</div>
}
